<template>
  <form @submit.prevent="subscribe" v-if="!success">


    <label for="subEmail">E-mail:</label>
    <input name="email" id="subEmail" type="email" v-model="email">

    <label for="subPhone">Телефон:</label>
    <input
      name="phone"
      id="subPhone"
      type="text"
      v-model="phone"
      v-input-mask
      data-inputmask-mask="+7 (999) 999 99 99"
    >
    <span class="form-error" v-if="error">{{error}}</span>

    <button type="submit" class="btn_green">Отправить</button>
  </form>
  <div v-else>
    Вы успешно подписаны
  </div>
</template>

<script>
  import CheckboxInput from './form/CheckBoxInput'
  import TextInput from './form/TextInput'
  import Phone from './Auth/Inputs/Phone'
  import axios from 'axios'
export default {
    name: 'Subscribe',
    components: { Phone, TextInput, CheckboxInput },
    created () {
      this.sessId = document.getElementsByName('ses_id').item(0).getAttribute('content')
      this.productId = document.getElementsByName('available_id').item(0).getAttribute('content')
      console.log(this.sess_id)
    },
    data () {
      return {
        sessId: '',
        productId: '',
        email: '',
        phone: '',
        error: '',
        success: false
      }
    },
    methods: {
      async subscribe () {
        this.error = false
        try {
          const result = await axios.post('availability/subscribe', {
            product_id: this.productId,
            email: this.email,
            phone: this.phone.replace(/[^0-9.]/g, '').substr(1)
          })

          if (result.data.success) {
            this.success = true
          }
        } catch (e) {
          this.error = e.response.data.error
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Subscribe.vue